export const buildMediaAssetIdParam = (mediaId, mediaAssetType) => {
  if (mediaAssetType === 'adMediaAsset') {
    return { ad_media_id: mediaId };
  }

  return { media_id: mediaId };
};
